<script setup>
const NORMAL_WIDTH = 1350;
const NORMAL_HEIGHT = 1380;
const GUTTERS = 16;

const props = defineProps({
  hall: { type: Object, required: true },
  poster: {
    type: String,
    required: true,
  },
  placeComponent: { type: Object, required: true },
  popupComponent: { type: [Object, null], default: null },
  tickets: { type: Array, default: () => [] },
  cart: { type: Array, default: () => [] },
});
const emit = defineEmits(["addTicketToCart", "removeTicketFromCart"]);

function onAddTicketToCart(e) {
  emit("addTicketToCart", e);
}

function onRemoveTicketFromCart(e) {
  emit("removeTicketFromCart", e);
}

const hall = reactive(props.hall);
const amphKeys = reactive(Object.keys(hall.amphitheater));
const partherKeys = reactive(Object.keys(hall.parther));

const getPlacesKeys = (places) => {
  return Object.keys(places).sort((a, b) => {
    a = Number(a);
    b = Number(a);
    return a - b;
  });
};

function getPartherPlaceGridPosition(row, place) {
  if (row === 9 || row === 8 || row === 7 || row === 6) {
    if (place <= 9)
      return `grid-area: row${row}-start / column${
        place + 1
      }-start / row${row}-end / column${place + 1}-end`;
    return `grid-area: row${row}-start / column${
      place + 3
    }-start / row${row}-end / column${place + 3}-end`;
  }
  if (row <= 5) {
    if (place <= 10)
      return `grid-area: row${row}-start / column${place}-start / row${row}-end / column${place}-end`;
    return `grid-area: row${row}-start / column${
      place + 2
    }-start / row${row}-end / column${place + 2}-end`;
  }
  return "";
}

const zoom = ref(1);

const maxHeight = ref("-webkit-fill-available");

const onWindowResize = () => {
  const width = window.innerWidth;
  if (width < NORMAL_WIDTH + 2 * GUTTERS) {
    zoom.value = width / (GUTTERS * 2 + NORMAL_WIDTH);
    maxHeight.value = `${zoom.value * NORMAL_HEIGHT + 25}px`;
  } else {
    zoom.value = 1;
    maxHeight.value = `${zoom.value * NORMAL_HEIGHT + 25}px`;
  }
};
onMounted(() => {
  window.addEventListener("resize", onWindowResize);
  onWindowResize();
});

onUnmounted(() => {
  window.removeEventListener("resize", onWindowResize);
});
</script>

<template>
  <div
    class="max-w-full w-full relative flex flex-row justify-center"
    :style="{ height: `${maxHeight}` }"
    ref="wrapper"
  >
    <div class="origin-top flex-auto" :style="`transform: scale(${zoom});`">
      <div class="w-full relative flex flex-col space-y-9">
        <p class="text-xl2 text-dark-gray leading-none text-center">
          Амфитеатр
        </p>

        <div class="amphitheater gap-3">
          <template
            v-for="(rowKey, index) in amphKeys"
            :key="rowKey + index + 'amphitheater'"
          >
            <div
              class="numb"
              :style="`grid-row: row${
                index + 1
              }-start / row${index}-end; grid-column: column0-start / column1-end`"
            >
              <span>{{ index + 1 }}</span>
            </div>
            <component
              :is="placeComponent"
              :popup-component="popupComponent"
              v-for="placeKey in getPlacesKeys(hall.amphitheater[rowKey])"
              :key="`${rowKey}, ${placeKey} place`"
              :row="rowKey"
              :hall-category="hall.cathegory"
              :place-key="placeKey"
              :place="hall.amphitheater[rowKey][placeKey]"
              :amphitheater="true"
              :parther="false"
              :tickets="tickets"
              :cart="cart"
              @add-ticket-to-cart="onAddTicketToCart"
              @remove-ticket-from-cart="onRemoveTicketFromCart"
              :style="`grid-row: row${
                index + 1
              }-start / row${index}-end; grid-column: column${placeKey}-start / column${placeKey}-end`"
            />
            <div
              class="numb"
              :style="`grid-row: row${
                index + 1
              }-start / row${index}-end; grid-column: column22-start / column23-end`"
            >
              <span>{{ index + 1 }}</span>
            </div>
          </template>
        </div>

        <p class="text-xl2 text-dark-gray leading-none text-center">Партер</p>

        <div class="parther gap-3">
          <template
            v-for="(rowKey, index) in partherKeys"
            :key="rowKey + index + 'partherKeys'"
          >
            <div
              class="numb"
              :style="`grid-row: row${rowKey}-start / row${rowKey}-end; grid-column: column0-start / column0-end`"
            >
              <span>{{ rowKey }}</span>
            </div>

            <component
              :is="placeComponent"
              :popup-component="popupComponent"
              v-for="placeKey in getPlacesKeys(hall.parther[rowKey])"
              :key="`${rowKey}, ${placeKey}`"
              :row="rowKey"
              :hall-category="hall.cathegory"
              :place-key="placeKey"
              :place="hall.parther[rowKey][placeKey]"
              :amphitheater="false"
              :parther="true"
              :tickets="tickets"
              :cart="cart"
              @add-ticket-to-cart="onAddTicketToCart"
              @remove-ticket-from-cart="onRemoveTicketFromCart"
              :style="
                getPartherPlaceGridPosition(Number(rowKey), Number(placeKey))
              "
            />
            <div
              class="numb"
              :style="`grid-row: row${rowKey}-start / row${rowKey}-end; grid-column: column24-start / column24-end`"
            >
              <span>{{ rowKey }}</span>
            </div>
          </template>
        </div>
        <div class="h-28 w-full bg-dark-gray flex rounded-lg">
          <p class="m-auto text-xl2 text-white font-sans">Сцена</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// .outter {
//   display: flex;
//   justify-content: center;
//   width: 100%;
//   flex-direction: row;
//   position: relative;

//   .zoomable {
//     // display: flex;
//     // justify-content: center;
//     transform-origin: top;
//     flex: 1 1 auto;

//     .tickTeatr {
//       width: 1140px;
//       height: 1082px;
//       position: relative;
//       margin: auto;
//     }
//   }
// }

.amphitheater {
  display: grid;
  justify-content: center;
  grid-template-columns: [column0-start] 36px [column0-end column1-start] 36px [column1-end column2-start] 36px [column2-end column3-start] 36px [column3-end column4-start] 36px [column4-end column5-start] 36px [column5-end column6-start] 36px [column6-end column7-start] 36px [column7-end column8-start] 36px [column8-end column9-start] 36px [column9-end column10-start] 36px [column10-end column11-start] 36px [column11-end column12-start] 36px [column12-end column13-start] 36px [column13-end column14-start] 36px [column14-end column15-start] 36px [column15-end column16-start] 36px [column16-end column17-start] 36px [column17-end column18-start] 36px [column18-end column19-start] 36px [column19-end column20-start] 36px [column20-end column21-start] 36px [column21-end column22-start] 36px [column22-end];
  grid-template-rows: [row13-end row14-start] 36px [row12-end row13-start] 36px [row11-end row12-start] 36px [row10-end row11-start] 36px [row9-end row10-start] 36px [row8-end row9-start] 36px [row7-end row8-start] 36px [row6-end row7-start] 36px [row5-end row6-start] 36px [row4-end row5-start] 36px [row3-end row4-start] 36px [row2-end row3-start] 36px [row1-end];

  .numb {
    cursor: default;
    color: gray;
    font-weight: 700;
    padding: 7px;
    text-align: center;
    height: 36px;
    width: 36px;
  }
}

.parther {
  position: relative;
  display: grid;
  justify-content: center;
  grid-template-columns: [column0-start] 36px [column0-end column1-start] 36px [column1-end column2-start] 36px [column2-end column3-start] 36px [column3-end column4-start] 36px [column4-end column5-start] 36px [column5-end column6-start] 36px [column6-end column7-start] 36px [column7-end column8-start] 36px [column8-end column9-start] 36px [column9-end column10-start] 36px [column10-end column11-start] 36px [column11-end column12-start] 36px [column12-end column13-start] 36px [column13-end column14-start] 36px [column14-end column15-start] 36px [column15-end column16-start] 36px [column16-end column17-start] 36px [column17-end column18-start] 36px [column18-end column19-start] 36px [column19-end column20-start] 36px [column20-end column21-start] 36px [column21-end column22-start] 36px [column22-end column23-start] 36px [column23-end];
  grid-template-rows: [row9-start] 36px [row9-end row8-start] 36px [row8-end row7-start] 36px [row7-end row6-start] 36px [row6-end row5-start] 36px [row5-end row4-start] 36px [row4-end row3-start] 36px [row3-end row2-start] 36px [row2-end row1-start] 36px [row1-end];

  .numb {
    cursor: default;
    color: gray;
    font-weight: 700;
    text-align: center;
    height: 36px;
    width: 36px;
  }
}

// .hdbuy p,
// .wacol p {
//   text-align: center;
//   font-size: 25px;
//   margin-top: 20px;
//   text-transform: uppercase;
//   color: #710024;
//   font-family: 'ConvMuseoSansCyrl900';
// }

// .footbuy {
//   text-align: center;
//   font-size: 25px;
//   text-transform: uppercase;
//   color: #fff;
//   font-family: 'ConvMuseoSansCyrl900';
//   border: 20px solid transparent;
//   border-top: 50px solid gray;
//   width: 400px;
//   margin: 0 auto;
//   display: block;
//   margin-top: 40px;
//   padding: 5px;
//   padding-bottom: 0px;
//   p {
//     color: #000 !important;
//   }
// }
</style>
